import {Model} from 'vue-mc'
import {required, string, validation} from 'vue-mc/validation'

export default class Organizator extends Model {
  defaults() {
    return {
      id: null,
      url_id: "",
      name: "",
      title: "",
      alias: "",
      banner_url: "",
      primary_color: "",
      secondary_color: ""
    }
  }
}
